import {BackgroundElementStyles} from "../elements/ElementStyles";
import {useContext, useEffect, useState} from "react";
import PlanerView from "./PlanerView";
import {stylesProgramPlanerView as stylesProgramPlannerView} from "./ProgramPlanerViewStyles";
import {weekdays} from "../ToDos";
import {APIContext} from "../Globals.tsx";
import {Modal} from "../Modal.tsx";
import TextInputWeex from "../elements/TextInputWeex";
import LabelSelectableWeex from "../elements/LabelSelectableWeex";
import editIcon from "../../img/edit.png";

export default function ProgramPlaner({
                                        weekProgramm,
                                        selectedCourseType,
                                        setSelectedCourseType,
                                        onSave,
                                        startOfWeek,
                                        date,
                                        preview = false
                                      }){
  const lineHeight = 1600 / 25;
  const raster = lineHeight; //todo remove

  const [mouse, setMouse] = useState({x: 0, y: 0});
  const [week, setWeek] = useState(weekProgramm);

  const [addComponent, setAddComponent] = useState(-1);
  const [addCoursePos, setAddCoursePos] = useState(-1);

  const [hoveredDay, setHoveredDay] = useState(-1);

  const [hoverItemHeight, setHoverItemHeight] = useState(lineHeight);
  const [hoverTop, setHoveredTop] = useState(-1);
  const [hoveredLeft, setHoveredLeft] = useState(-1);
  const [hoveredWidth, setHoveredWidth] = useState(-1);

  const [editValues, setEditValues] = useState(null);

  const [draggedItem, setDraggedItem] = useState(null);
  const [resizeItem, setResizeItem] = useState(null);

  const [courseTypes, setCourseTypes] = useState(null);
  const [tags, setTags] = useState(null);

  const [weekdays_, setWeekdays] = useState(null);

  const [cFImporter, setCFImporter] = useState(false);

  const padding = parseInt(BackgroundElementStyles.paddingLabels.split(" ")[1]);

  const {fetchCourseTypes, getTags} = useContext(APIContext);

  function startToInt(start){
    return Math.round(start / 100) + ((start % 100) / 60);
  }

  function checkEmpties(week){
    return week.map(day =>
      !day ? [{
        description: "Kein Kurs an diesem Tag gefunden",
        fixed: true,
        height: "100"
      }] : day
    );
  }

  useEffect(() => {
    if(date){
      setWeek(checkEmpties([weekProgramm[0]]));
    }
    else{
      setWeek(checkEmpties(weekProgramm));
    }
  }, [weekProgramm]);

  useEffect(() => {
    setMouse((old) => [old.x, old.y + 1]);
    setHoveredTop(getTop(-1));
    setHoveredLeft(getLeft(-1));
    setHoveredWidth(getWidthOfDay(-1));
  }, [addComponent]);

  function setTags_(ans){
    let tags = ans?.tags?.map((tag) => {
      return {
        label: tag.name,
        value: tag.id,
        ...tag
      };
    });
    setTags(tags ?? null);
  }

  useEffect(() => {
    fetchCourseTypes().then(ans => {
      const courseTypesTmp = ans?.types?.map(a => {
        return ({
          value: a.name,
          label: a.name,
          ...a
        });
      });
      setSelectedCourseType(courseTypesTmp ? courseTypesTmp[0] : null);
      setCourseTypes(courseTypesTmp);
    });
    getTags().then(ans => setTags_(ans));
  }, []);

  useEffect(() => {
    if(date){
      const dayOfWeek = ((new Date(date)).getDay() + 6) % 7;
      setWeekdays([weekdays[dayOfWeek]]);
    }
    else{
      setWeekdays(weekdays);
    }
  }, [date]);

  function handleMouseMove(e){
    const target = document.getElementById("DnDArea").getBoundingClientRect();
    if(e.clientY === 0){ //happens on drag-end via onDrag listener, just suppress
      return;
    }
    setMouse({
      x: e.clientX - target.left,
      y: e.clientY - target.top
    });
    setEditValues(null);
    if(e.clientX < target.left ||
      e.clientX > target.right ||
      e.clientY < target.top ||
      e.clientY > target.bottom){
      setHoveredDay(-1);
    }
    if(addComponent === -1){
      setHoveredTop(getTop(-1));
      setHoveredLeft(getLeft(-1));
      setHoveredWidth(getWidthOfDay(-1));
    }
  }

  function handleClick(e){
    if(addComponent === hoveredDay || e.isDefaultPrevented() || week[hoveredDay][0]?.fixed){
      return;
    }
    setAddComponent(hoveredDay);
    setAddCoursePos(getTop());
  }

  function getLeft(day){
    if(day > -1){
      return document.getElementById("p_day_" + day)?.getBoundingClientRect().left + padding;
    }
    return document.getElementById("p_day_" + hoveredDay)?.getBoundingClientRect().left;
  }

  function getWidthOfDay(day){
    let target;
    if(day > -1){
      target = document.getElementById("p_day_" + day)?.getBoundingClientRect();
      return target?.right - target?.left - padding * 2;
    }
    else{
      target = document.getElementById("p_day_" + hoveredDay)?.getBoundingClientRect();
      return target?.right - target?.left;
    }
  }

  function getWidthForElementRender(){
    return "100%";
  }

  function getTop(){
    return Math.floor(mouse.y / (lineHeight / raster)) * (lineHeight / raster);
  }

  function calcPxToTime(px){
    const tmp = (px / lineHeight) - 1;
    const hour = Math.floor(tmp);
    const min = (tmp - hour) * 60;
    return hour.toString().padStart(2, "0") + ":" + min.toString().padStart(2, "0");
  }

  function getTopOfItem(day, index){
    const itemTop = document.getElementById("item_" + day + "_" + index).getBoundingClientRect().top;
    const containerTop = document.getElementById("DnDArea").getBoundingClientRect().top;
    return itemTop - containerTop;
  }

  function handleDragEnd(){
    let tmp = [...week];
    if(tmp[hoveredDay][0]?.fixed){
      return;
    }
    //calc top of every item
    tmp[draggedItem] = tmp[hoveredDay].map((e, i) => e.top = getTopOfItem(hoveredDay, i));

    let item = tmp[draggedItem.hoveredDay][draggedItem.i];

    //remove item from old day
    tmp[draggedItem.hoveredDay] = tmp[draggedItem.hoveredDay].filter((_, i) => i !== draggedItem.i);

    //search where to drop item in the list of items on new day
    let firstHit = tmp[hoveredDay].find((element, index) => {
      if(element.top > getTop()){
        //found this on internet to insert item on position index
        tmp[hoveredDay] = [...tmp[hoveredDay].slice(0, index), item, ...tmp[hoveredDay].slice(index)];
        return true;
      }
    });
    if(!firstHit){
      tmp[hoveredDay].push(item);
    }
    setDraggedItem(null);
    setWeek(tmp);
    onSave(tmp);
  }

  function addProgrammToWeek(props){
    let tmp = [...week];
    if(!props.index){
      if(!props.edit){
        tmp[addComponent].push(props);
      }
      else{
        tmp = tmp.map(day => day.map(e => e.id === props.id ? props : e));
      }
    }
    else{
      tmp[addComponent][props.index] = {
        type: props.type,
        time: props.time,
        duration: props.duration,
        program: "p1",
        coach: props.coach,
        participants: [],
        participantsMax: 12
      };
    }
    setAddComponent(-1);
    setWeek(tmp);
    onSave(tmp);
  }

  function onDelete(e, index, i){
    let tmp = [...week];
    tmp[index] = tmp[index].filter((_, ii) => ii !== i);
    setWeek(tmp);
    onSave(tmp);

    e.preventDefault();
  }

  function onImport(importWorkouts){
    let tmp = [...week];
    importWorkouts.map((day, i) => {
      tmp[i] = [...tmp[i], ...day.components.filter(c => c.selected === true)];
    });
    setWeek(tmp);
    onSave(tmp);
  }

  return (<>
    <PlanerView getWidth={getWidthForElementRender} setHoverItemHeight={setHoverItemHeight}
                addToWeek={addProgrammToWeek}
                hoverItemHeight={hoverItemHeight} setDraggedItem={setDraggedItem} addCoursePos={addCoursePos}
                week={week} addModal={addComponent} setAddModal={setAddComponent} calcPxToTime={calcPxToTime}
                draggedItem={draggedItem} editValues={editValues} hoveredWidth={hoveredWidth}
                handleDragEnd={handleDragEnd} hoveredDay={hoveredDay}
                hoveredLeft={hoveredLeft} getLeft={getLeft} hoverTop={hoverTop} getTop={getTop}
                lineHeight={lineHeight} handleClick={handleClick} handleMouseMove={handleMouseMove}
                resizeItem={resizeItem} setResizeItem={setResizeItem} setEditValues={setEditValues}
                setHoveredDay={setHoveredDay} setSelectedCourseType={setSelectedCourseType}
                startToInt={startToInt} stylesPlanerView={stylesProgramPlannerView} isSchedulePlaner={false}
                courseTypes={courseTypes} selectedCourseType={selectedCourseType} getWidthOfDay={getWidthOfDay}
                weekdays={weekdays_} tags={tags} setTags={setTags_} preview={preview} onDelete={onDelete}
                onImport={() => setCFImporter(true)}
    />
    <CrossfitComImporter cFImporter={cFImporter} setCFImporter={setCFImporter} startOfWeek={startOfWeek}
                         onSave={onImport}/>
  </>);
}

function CrossfitComImporter({cFImporter, setCFImporter, startOfWeek, onSave}){

  const [importToken, setImportToken] = useState("");
  const [importWorkouts, setImportWorkouts] = useState(null);

  const {fetchCrossfitWorkouts, translate} = useContext(APIContext);

  const labelSelectStyle = {
    background: "var(--accent)",
    margin: 10,
    color: "var(--background)",
    fontWeight: "bold"
  };

  function html2Text(html){
    html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
    html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
    html = html.replace(/<\/div>/ig, '\n');
    html = html.replace(/<\/li>/ig, '\n');
    html = html.replace(/<li>/ig, '  *  ');
    html = html.replace(/<\/ul>/ig, '\n');
    html = html.replace(/<\/p>/ig, '\n\n');
    html = html.replace(/<br\s*[\/]?>/gi, "");
    html = html.replace(/<[^>]+>/ig, '');
    html = html.replace(/&#8211;/g, '-');
    html = html.replace(/&#8217;/g, '\'');
    html = html.replace(/&#8220;/g, '\"');
    html = html.replace(/&#8221;/g, '\"');
    html = html.replace(/&#8764;/g, '~');
    return html;
  }

  async function doImport(){
    let day = new Date(new Date(startOfWeek).setHours(6)).toISOString().split("T")[0];
    fetchCrossfitWorkouts(importToken, day, 7).then(ans => {
      if(ans){
        setImportWorkouts(ans.days.map(day => (
          {
            original: day,
            components: day.count <= 0 ? [] : [...day.tiles?.map(tile => tile?.acf?.class_plan.filter(comp => comp.components?.filter(c => c.acf_fc_layout === "wysiwyg").length).map(c => ({
              selected: true,
              name: c.title,
              timeCap: c.duration,
              description: html2Text(c.components?.filter(c => c.acf_fc_layout === "wysiwyg").reduce((red, ele) => red + (ele.body ?? ""), "")),
              workout: false,
              tags: []
            }))).reduce((red, ele) => [...red, ...ele], []), ...day.tiles?.map(tile => tile?.acf?.workouts.map(c => ({
              selected: true,
              name: c.level,
              timeCap: tile?.acf?.class_plan.find(comp => comp.title === "workout").duration,
              description: html2Text(c.description),
              score: c.score,
              workout: true,
              tags: []
            }))).reduce((red, ele) => [...red, ...ele], [])]
          }
        )));
      }
    });
  }

  return (<div>
    {importWorkouts &&
      <Modal actionP={() => {
        onSave(importWorkouts);
        setImportWorkouts(null);
      }} actionS={() => setImportWorkouts(null)}
             buttonP={"Hinzufügen"} buttonS={"Abbrechen"} valid={true}>
        <div style={{display: "flex", flexDirection: "row", overflow: "scroll"}}>
          {importWorkouts.map((day, i) =>
            <div>
              <LabelSelectableWeex style={{...labelSelectStyle, background: "none", color: "var(--white)"}}
                                   selected={!day.components?.some(c => !c.selected)} setSelected={(s) => {
                day.components.map(c => c.selected = s);
                setImportWorkouts([...importWorkouts]);
              }}>
                <h2>{new Date((new Date(startOfWeek)).setDate((new Date(startOfWeek)).getDate() + i)).toDateString()}</h2>
              </LabelSelectableWeex>
              <div>
                {day.components?.filter(c => c.workout === false).map((component) =>
                  <LabelSelectableWeex style={labelSelectStyle} tooltip={
                    <div dangerouslySetInnerHTML={{__html: component.description}}/>
                  } selected={component.selected} setSelected={(s) => {
                    component.selected = s;
                    setImportWorkouts([...importWorkouts]);
                  }}>
                    {component.name}
                    <img className={"icon none-mobile-tile"} src={editIcon}
                         onClick={() => translate(component.description).then(e=> {
                           let tmp = [...importWorkouts]
                           component.description = e
                           tmp[i].components = tmp[i].components.map(comp => {
                             if (comp.name === component.name)
                               return component
                             return comp
                           })
                           setImportWorkouts(tmp);
                         })} alt={"edit"}/>
                  </LabelSelectableWeex>
                )}
                <br/>
                <h3>Workout</h3>
                {day.components?.filter(c => c.workout === true).map((component) =>
                  <div style={{padding: "10px"}}>
                    <LabelSelectableWeex style={labelSelectStyle} selected={component.selected} setSelected={(s) => {
                      component.selected = s;
                      setImportWorkouts([...importWorkouts]);
                    }}>{component.name}</LabelSelectableWeex>
                    <div style={{whiteSpace: "break-spaces"}}>{component.description}</div>
                    <p>Score: {component.score}</p>
                    <p>Timecap: {component.timeCap} min</p>
                  </div>
                )
                }
              </div>
            </div>
          )}
        </div>
      </Modal>
    }
    {cFImporter &&
      <Modal actionP={() => {
        setCFImporter(false);
        doImport();
      }} buttonP={"Importieren"} actionS={() => {
        setCFImporter(false);
        setImportToken(null);
      }} buttonS={"Abbrechen"} valid={importToken?.length} header={"Authorisierung"}>
        <div style={{textAlign: "left"}}>
          Wir brauchen einen Token um in deinen Namen die Workouts von crossfit.com zu holen.<br/><br/>

          Befolge folgende Schritte hierfür:
          <ul>
            <li>Öffne <a href={"https://affiliate.crossfit.com/tools/programming/cap"} target={"_blank"}
                         style={{color: "var(--accent)"}}>affiliate.crossfit.com/tools/programming/cap</a></li>
            <li>Log dich mit deinen Nutzer ein.</li>
            <li>Öffne die Entwicklertools deines Browser (F12).</li>
            <li>Öffne den Reiter Applikation.</li>
            <li>Öffne den Local Storage für die Domain "affiliate.crossfit.com".</li>
            <li>Kopiere den Wert des Schlüssels "access_token" und füge ihn unten ein.</li>
          </ul>
          <TextInputWeex onChange={(e) => setImportToken(e.target.value)} value={importToken} label={"Token"}
                         placeholder={"Token"} light={true}/>
        </div>
      </Modal>
    }
  </div>);
}